import {connect} from 'react-redux';
import {getTranslation} from '../../../reducers/common/localization';
import ValidatedDomainsList from './ValidatedDomainsList';
import {
    fetchGetValidatedDomains, fetchGetValidatedDomainsByCountry, fetchGetValidatedDomainsByNameAndDomain,
    getValidatedDomainsFormattedData,
    loadingValidatedDomains, setValidatedDomainsCountryFilter,
    setValidatedDomainsDomainFilter, setValidatedDomainsNameFilter
} from '../../../reducers/accreditation/validatedDomains';
import {
    getContinentsData,
    getCountriesData,
    getCurrentContinent,
    setCurrentContinent
} from '../../../reducers/common/location';
import {
    getActiveModal,
    MODAL_EDIT_VALIDATED_DOMAIN, MODAL_APPLICANT_REQUESTS, MODAL_REMOVE_VALIDATED_DOMAIN,
    MODAL_ADD_VALIDATED_DOMAIN,
    showModal
} from '../../../reducers/common/activeModal';
import {fetchGetLastRequestorsOfAccreditationRequest} from '../../../reducers/accreditation/unreferencedAccreditationRequests';
import {resetSubmitFormData} from '../../../reducers/common/submitForm';

const mapStateToProps = state => {
    return {
        loading: loadingValidatedDomains(state),
        translation: getTranslation(state),
        data: getValidatedDomainsFormattedData(state),
        continents: getContinentsData(state),
        continentCode: getCurrentContinent(state),
        countries: getCountriesData(state),
        modalOpen: [MODAL_ADD_VALIDATED_DOMAIN, MODAL_EDIT_VALIDATED_DOMAIN].includes(getActiveModal(state).modalKey)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(setValidatedDomainsNameFilter(null));
            dispatch(setValidatedDomainsDomainFilter(null));
            dispatch(setValidatedDomainsCountryFilter(null));
            dispatch(setCurrentContinent(''));
            dispatch(fetchGetValidatedDomains());
        },
        onChangeCountryFilter: (countryCode) => {
            dispatch(fetchGetValidatedDomainsByCountry(countryCode));
        },
        onSetContinent: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onFilter: (name, domain) => {
            dispatch(fetchGetValidatedDomainsByNameAndDomain(name, domain));
        },
        onRemove: () => {
            dispatch(resetSubmitFormData());
            dispatch(showModal({modalKey: MODAL_REMOVE_VALIDATED_DOMAIN}));
        },
        onAddDomain: () => {
            dispatch(resetSubmitFormData());
            dispatch(showModal({modalKey: MODAL_ADD_VALIDATED_DOMAIN}));
        },
        onEditDomain: () => {
            dispatch(resetSubmitFormData());
            dispatch(showModal({modalKey: MODAL_EDIT_VALIDATED_DOMAIN}))
        },
        onShowApplicantRequests: (domain) => {
            dispatch(fetchGetLastRequestorsOfAccreditationRequest(domain));
            dispatch(showModal({modalKey: MODAL_APPLICANT_REQUESTS}));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ValidatedDomainsList);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/validatedDomainsList/ValidatedDomainsList.container.js